module.exports={
    "两次输入的密码必须一致": "รหัสผ่านควรตรงกัน",
    "取消": "ยกเลิก",
    "如验证出现问题，请点击": "กรุณากดตรงนี้ในกรณีเจอปัญหาการตรวจสอบ",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "กรุณาติดต่อorcalivecs@asiainnovations.comในกรณีปัญหาการตรวจสอบความถูกต้อง",
    "如验证出现问题，请联系upcs@asiainnovations.com": "กรุณาติดต่อ upcs@asiainnovations.com ในกรณีเจอปัญหาการตรวจสอบ",
    "密码修改成功": "รหัสผ่านแก้ไขสำเร็จ",
    "密码格式错误": "รูปแบบของรหัสผ่านผิด",
    "密码由6-20位由数字和字母组成": "รหัสผ่านประกอบด้วยตัวอักษรและตัวเลข 6 ถึง 20ตัว",
    "恭喜您密码重置成功": "ยินดีด้วย รหัสผ่านของคุณรีเซตรสำเร็จ",
    "恭喜您已成功激活帐户": "ยินดีด้วย รหัสผ่านของคุณรีเซตรสำเร็จแล้ว",
    "知道了": "รับทราบแล้ว",
    "确认修改": "ยืนยันที่จะแก้ไข",
    "网络连接有误, 请稍后再试": "ข้อผิดพลาดในการเชื่อมต่อเครือข่าย โปรดลองอีกครั้งในภายหลัง",
    "联系客服": "ติดต่อทีมงาน",
    "请再次输入密码": "กรุณาอิทพุทรหัสผ่านใหม่",
    "请返回UpVoice中重新进行邮箱验证": "กลับไปที่ UpVoice และตรวจสอบด้วยบัญชีอีเมลของคุณอีกครั้ง",
    "请返回Up直播中重新进行邮箱验证": "กลับไปที่ Uplive และตรวจสอบด้วยบัญชีอีเมลของคุณอีกครั้ง",
    "请返回虎鲸直播中重新进行邮箱验证": "กลับไปที่ OrcaLive และตรวจสอบด้วยบัญชีอีเมลของคุณอีกครั้ง",
    "请重新设定登录密码": "กรุณารีเซ็ตรหัสผ่านของคุณ",
    "请重新设置密码": "กรุณาตั้งค่ารหัสผ่านใหม่",
    "赶快返回UpVoice中与全球潮人互动吧": "รีบกลับไปที่ UpVoice และเล่นกับเพื่อนทั่วโลกของคุณ!",
    "赶快返回Up直播中与全球潮人互动吧！": "รีบกลับไปที่ Uplive และเล่นกับเพื่อนทั่วโลกของคุณ!",
    "赶快返回虎鲸直播中与全球潮人互动吧": "รีบกลับไปที่ OrcaLive และเล่นกับเพื่อนทั่วโลกของคุณ!",
    "重置密码失败": "การตั้งค่ารหัสผ่านใหม่ล้มเหลว",
    "验证失败": "การตรวจสอบความถูกต้องล้มเหลว",
    "验证成功": "ตรวจสอบสำเร็จ"
};


// WEBPACK FOOTER //
// ./js/lang/thth.js